export const REGISTER_TYPES = {
  TYPE_LOCAL: 1,
  TYPE_CUSTOM: 2,
};

export const SYSTEMS_NAMES = {
  VCHT: 'VCHT',
  EVENTS: 'EVENTS',
  EVENTS_DEV: 'EVENTS_DEV',
};

export const ASSIGN_TYPES = {
  [SYSTEMS_NAMES.EVENTS]: 1,
  [SYSTEMS_NAMES.VCHT]: 2,
  [SYSTEMS_NAMES.EVENTS_DEV]: 3,
};

export const SYSTEMS = {
  [SYSTEMS_NAMES.VCHT]: 'https://afisha.dop.edu.ru',
  [SYSTEMS_NAMES.EVENTS]: 'https://events.pfdo.ru',
  [SYSTEMS_NAMES.EVENTS_DEV]: 'https://evma-dev.pfdo.ru',
};

export const SYSTEMS_API = {
  [ASSIGN_TYPES[SYSTEMS_NAMES.EVENTS]]: 'https://api-events.pfdo.ru/v1',
  [ASSIGN_TYPES[SYSTEMS_NAMES.VCHT]]: 'https://api.dop.edu.ru/v1',
  [ASSIGN_TYPES[SYSTEMS_NAMES.EVENTS_DEV]]: 'https://api-evma-dev.pfdo.ru/v1',
};

export const SYSTEMS_API_NAMED_KEYS = {
  [SYSTEMS_NAMES.VCHT]: SYSTEMS_API[ASSIGN_TYPES[SYSTEMS_NAMES.VCHT]],
  [SYSTEMS_NAMES.EVENTS]: SYSTEMS_API[ASSIGN_TYPES[SYSTEMS_NAMES.EVENTS]],
  [SYSTEMS_NAMES.EVENTS_DEV]: SYSTEMS_API[ASSIGN_TYPES[SYSTEMS_NAMES.EVENTS_DEV]],
};
